var map = {
	"./en-AU/en-AU.json": 32234,
	"./en-GB/en-GB.json": 86306,
	"./en-US/en-US.json": 96466,
	"./en/en.json": 76042,
	"./fr-FR/fr-FR.json": 96674,
	"./it/it.json": 89794,
	"./ja/ja.json": 59426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70779;